import { render } from "./GameMail.vue?vue&type=template&id=9885f7a6&scoped=true"
import script from "./GameMail.vue?vue&type=script&lang=ts"
export * from "./GameMail.vue?vue&type=script&lang=ts"

import "./GameMail.vue?vue&type=style&index=0&id=9885f7a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9885f7a6"

export default script